import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Layout } from 'antd'
import { HeaderSection } from 'app/components/Layouts'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import ModernTabNavigation from '../../components/ModernTabNavigation'
import PositionClosed from './PositionClosed'
import ExchangeRealtime from './ExchangeRealtime'
import { APPNAME } from 'app/constants/APIKEYS'

const StyledLayout = styled(Layout)`
  background: #f8f9fa;
  min-height: 100vh;
`

const StyledContent = styled(Layout.Content)`
  padding: 0 50px 20px;

  @media (max-width: 768px) {
    padding: 0 5px 20px;
  }
`
export const AdminPositionPage = () => {
	const location = useLocation()
	const url = location.pathname

	const items = [
		{
			title: '활성 포지션',
			link: '/position/open',
		},
		{
			title: '완료 포지션',
			link: '/position/closed',
		},
	]

	const renderContent = () => {
		switch (url) {
			case '/position/open':
				return <ExchangeRealtime title={'활성 포지션'} />
			case '/position/closed':
				return <PositionClosed title={'완료 포지션'} />
			default:
				return <ExchangeRealtime title={'활성 포지션'} />
		}
	}

	return (
		<StyledLayout>
			<Helmet>
				<title>{APPNAME} ADMIN - 포지션관리</title>
			</Helmet>
			<HeaderSection />
			<ModernTabNavigation items={items} />
			<StyledContent>
				{renderContent()}
			</StyledContent>
		</StyledLayout>
	)
}
